import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
const forYou = ['Sientes hinchazón frecuente y quieres entender por qué', 'Buscas hábitos simples que puedas mantener a largo plazo', 'Prefieres soluciones naturales sin medicamentos', 'Quieres un plan claro, paso a paso, sin complicaciones', 'Estás dispuesta a dedicar 7 días a tu bienestar'];
const notForYou = ['Buscas un diagnóstico médico o tratamiento clínico', 'Esperas resultados mágicos sin hacer cambios', 'Necesitas un plan personalizado por un profesional'];
export function ForWhoSection() {
  return <section className="bg-wellness-white py-20 px-6" id="for-who" data-id="element-74">
      <div className="max-w-5xl mx-auto" data-id="element-75">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-76">
          {/* For You Column */}
          <div className="bg-wellness-light-sage/30 rounded-2xl p-8" data-id="element-77">
            <h3 className="text-xl font-bold text-wellness-green mb-6" data-id="element-78">
              Esta guía es para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-79">
              {forYou.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-80">
                  <CheckCircle2 className="w-5 h-5 text-wellness-green flex-shrink-0 mt-0.5" data-id="element-81" />
                  <span className="text-wellness-dark" data-id="element-82">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Not For You Column */}
          <div className="bg-gray-50 rounded-2xl p-8" data-id="element-83">
            <h3 className="text-xl font-bold text-gray-500 mb-6" data-id="element-84">
              No es para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-85">
              {notForYou.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-86">
                  <X className="w-5 h-5 text-gray-400 flex-shrink-0 mt-0.5" data-id="element-87" />
                  <span className="text-gray-600" data-id="element-88">{item}</span>
                </li>)}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>;
}